import { LocationSummary } from "../../constants/action-constants/LocationSummaryActionConstants";

export const getLocationSummary = (data) => ({
  type: LocationSummary.GET_LOCATION_SUMMARY,
  payload: data,
});

export const resetLocationSummary = () => ({
  type: LocationSummary.RESET_LOCATION_SUMMARY,
});

//  "Mu" form
export const openLandmarkNearbyForm = () => ({
  type: LocationSummary.OPEN_LANDMARK_NEARBY_MODAL,
});

export const closeLandmarkNearbyForm = () => ({
  type: LocationSummary.CLOSE_LANDMARK_NEARBY_MODAL,
});
